import { createPinia } from 'pinia'

export default createPinia()

export * from './auth'
export * from './forms'
export * from './global-store'
export * from './odkSync'
